import buildCleanCampaignKey from './buildCleanCampaignKey'

const buildUtmCampaign = ({ title, relatedPromoStartDate, campaignDate }) =>
  buildCleanCampaignKey({
    title,
    relatedPromoStartDate,
    campaignDate,
  })

export default buildUtmCampaign
